/**
 *
 *添加存货相关处理
 * @export
 * @class AddInventoryProcessorBlock
 * @auther 马坚
 */


// 自由项相关处理
import { FreeItemsProcessor } from './freeItem/FreeItemsProcessor'
// 自定义项处理
import { HandlePriuserdefInfoProcessorBlock } from './priuserdefinfo/HandlePriuserdefInfoProcessorBlock'
/**批号拆分处理 */
import { BatchSplitProcessorBlock } from './batch/BatchSplitProcessorBlock'
/**零售价改变，计算价税额 */
import { RetailPriceChangeProcessor } from './priceAmount/RetailPriceChangeProcessor'
/**合并明细重复行 */
import { MergeDetailsProcessorBlock } from './MergeDetailsProcessorBlock'
/**处理明细的编码 */
import { DetailCodeProcessor } from './DetailCodeProcessor';
/**计算表头概要 */
import { SummaryProcessorBlock } from './summary/SummaryProcessorBlock';
/**单品打折 */
import { RunSinglePromotionProcessBlock } from './promotion/RunSinglePromotionProcessBlock';
/**数量改变事件 */
import { QuantityChangeProcessorBlock } from './quantity/QuantityChangeProcessorBlock';
/**数量2改变事件 */
import { Quantity2ChangeProcessorBlock } from './quantity/Quantity2ChangeProcessorBlock';
/**导购相关处理 */
import { PersonProcessBlock } from './person/PersonProcessBlock';
/**整单赠送 */
import { WholePresentProcessorBlock } from './WholePresentProcessorBlock';
/**可用量相关处理 */
import { AvailableQuantityProcess } from './available/AvailableQuantityProcess';
/** 序列号处理 */
import { SerialNumberProcessor } from './serialNumber/SerialNumberProcessor';
import '../../commom/Challenger';
import { runInAction } from 'mobx';

export class AddInventoryProcessorBlock {
  static async execute(
    dto,
    retailDetail,
    updatedDetail,
    targetIndex) {
    $T.debugger();
    // 自由项处理
    FreeItemsProcessor.execute(retailDetail, updatedDetail.FreeItems, false);
    // 自定义项
    HandlePriuserdefInfoProcessorBlock.execute(dto, retailDetail, retailDetail);
    // 当录入零售价的场合
    RetailPriceChangeProcessor.execute(dto, retailDetail, updatedDetail.RetailPrice);
    // 录入数量的场合
    QuantityChangeProcessorBlock.execute(dto, retailDetail, updatedDetail.Quantity, {});
    // 录入数量2的场合
    Quantity2ChangeProcessorBlock.execute(dto, retailDetail, updatedDetail.Quantity2, {});

    if (dto.Idperson && !updatedDetail.Idperson) {
      // 整单导购的场合，明细的导购=把表头的导购
      updatedDetail.person = dto.Person;
    }

    //录入序列号的场合
    SerialNumberProcessor.execute(dto, retailDetail, updatedDetail);
    // 导购相关处理
    PersonProcessBlock.execute(dto, retailDetail, updatedDetail);

    // 如果有批号，执行拆行动作
    BatchSplitProcessorBlock.execute(dto, retailDetail, updatedDetail,targetIndex);

    // 合并重复行
    // MergeDetailsProcessorBlock.execute(dto, detailList);

    // 处理明细的编码
    DetailCodeProcessor.execute(dto);

    if (!dto.IsPresent) {
      // 单品促销相关处理
      RunSinglePromotionProcessBlock.execute(dto, retailDetail, true);
    }


    // 整单赠送
    if (dto.IsPresent) {
      WholePresentProcessorBlock.execute(dto);
    }

    // 合并重复行
    MergeDetailsProcessorBlock.execute(dto,targetIndex);
    $T.debugger();
    // 处理明细的编码
    DetailCodeProcessor.execute(dto);
    // 处理表头相关值
    SummaryProcessorBlock.execute(dto);
    // 批号或自由项改变时，重取可用量
    if (updatedDetail.FreeItems || updatedDetail.Batchs) {
      await AvailableQuantityProcess.execute(dto);
    }
    $T.debugger();
  }
}